import { render, staticRenderFns } from "./SubjectComponent.vue?vue&type=template&id=8c367c4e&"
import script from "./SubjectComponent.vue?vue&type=script&lang=js&"
export * from "./SubjectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports